var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showCrediExpert
    ? _c(
        "div",
        { staticClass: "card-item mt-6", attrs: { id: "credi-experto" } },
        [
          _c("h3", { staticClass: "title is-5 has-text-primary" }, [
            _vm._v("Sua executiva"),
          ]),
          _c(
            "div",
            {
              staticClass: "avatar avatar-xxl profile-cover-avatar",
              attrs: { for: "avatar_upload" },
            },
            [
              _c("img", {
                staticClass: "avatar-img",
                attrs: {
                  src: _vm.crediExpert.photo,
                  alt: _vm.crediExpert.name,
                },
              }),
            ]
          ),
          _c("p", { staticClass: "avatar-name" }, [
            _vm._v(_vm._s(_vm.crediExpert.name)),
          ]),
          _c("div", { staticClass: "is-centered has-text-centered" }, [
            _c(
              "a",
              {
                staticClass: "expert-data",
                attrs: {
                  id: "credi-experto-whatsapp",
                  href: "#credi-experto-whatsapp",
                },
                on: {
                  click: function ($event) {
                    return _vm.clickEvent(
                      `https://wa.me/+${_vm.crediExpert.phone}?texto=Ol%C3%A1%2C%20preciso%20da%20sua%20ajuda.`,
                      "whatsapp"
                    )
                  },
                },
              },
              [_vm._m(0), _vm._v(" +" + _vm._s(_vm.crediExpert.phone))]
            ),
            _c(
              "a",
              {
                staticClass: "expert-data",
                attrs: {
                  id: "credi-experto-email",
                  href: "#credi-experto-email",
                },
                on: {
                  click: function ($event) {
                    return _vm.clickEvent(
                      `mailto:${_vm.crediExpert.email}?subject=Ol%C3%A1%2C%20preciso%20da%20sua%20ajuda.`,
                      "email"
                    )
                  },
                },
              },
              [_vm._m(1), _vm._v(" " + _vm._s(_vm.crediExpert.email))]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "expert-icon" }, [
      _c("i", { staticClass: "fa-brands fa-whatsapp fa-bounce" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "expert-icon" }, [
      _c("i", { staticClass: "fa-solid fa-envelope fa-bounce" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }